$(document).ready(() => {
  $.validator.addMethod('filesize', function (value, element, param) {
    return this.optional(element) || (element.files[0].size <= param)
  }, 'File size must be less than {0}');


  $(".application-form").validate({
    rules: {
      field: {
        required: true,
      },
      email: {
        email: true,
      },
      uploadCV: {
        filesize: 10485760, //10MB in bytes
        accept: "pdf",
      },
    },
    messages: {
      required: true,
      uploadCV: "File must be PDF and less than 10MB",
    },
  });

  $(document).on('submit', '.application-form', function(e) {
    e.preventDefault();

    var form = $(this);
    var formdata = false;
    if (window.FormData){
      formdata = new FormData(form[0]);
    }

    $.ajax({
      url: form.attr('action'),
      type: form.attr('method'),
      data: formdata ? formdata : form.serialize(),
      cache: false,
      contentType: false,
      processData: false,
      beforeSend:function( ) {
        $('form .button').html('Processing');
      },
      success:function(data) {
        $('#results').html(data);
        $('.button').html('Sent');
        $('.form').trigger('reset');
      },
      error:function() {
        $('#results').html('It borked!');
      },
    });
  });
});
